import React from 'react';

export default function BrandMark({ className = "w-10 h-10", color = "#00F0FF" }) {
  return (
    <div className={`relative ${className} flex items-center justify-center`}>
      {/* Outer Orbit */}
      <svg viewBox="0 0 100 100" className="absolute inset-0 animate-[spin_10s_linear_infinite]">
        <circle cx="50" cy="50" r="48" fill="none" stroke={color} strokeWidth="1" strokeDasharray="10 20" opacity="0.3" />
      </svg>
      
      {/* Route Path SVG */}
      <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full relative z-10">
        <path d="M20 80L40 40L60 60L80 20" stroke={color} strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="20" cy="80" r="6" fill={color} />
        <circle cx="80" cy="20" r="6" fill="#FF6B6B" />
        <path d="M40 40C45 30 55 30 60 40" stroke={color} strokeWidth="2" strokeDasharray="4 4" opacity="0.5" />
      </svg>
      
      {/* Glow Effect */}
      <div className="absolute inset-2 bg-cyan-400/20 blur-xl rounded-full"></div>
    </div>
  );
}